import React from 'react'

const SuggestedProductCardImage = ({ product, className = "" }) => {
    return (
        <div className={`${className}`}>
            {product.imageUrl && (
                <a href={product.url}>
                    <img className="image" src={product.imageUrl} alt={product.imageAltText} />
                </a>
            )}
        </div>
    )
}

export default SuggestedProductCardImage